import React, { useEffect, useMemo, useRef, useState } from 'react'

/**
 * @function Pagination
 * 
 * Provides basic pagination with calls to passed functional props
 * 
 **/ 
const Pagination = ({ count,
                      size, 
                      pageIndex,
                      gotoPage, 
                      firstPage, 
                      prevPage, 
                      nextPage, 
                      lastPage }) => {
  const pageCount = Math.ceil(( count ?? 0 ) / size)

  // TODO: Set is-disabled or whatever on the current page
  // TODO: Set is-disabled on first, prev if we're on the first page
  // TODO: Set is-disabled on last, next, last if we're on the last page
  const sliced = useMemo( () => {
    const pages = Array.from(Array(pageCount), (_,i) => i + 1)

    // Slice pages leaving a chunk of three at the start, or a window around `pageIndex`
    const snipStart = (pageIndex ?? 0) > 2 ? pageIndex - 2 : 0 
    // Clamp the end so it doesn't repeat the end page if it exists
    const snipEnd = (pageIndex ?? 0) > 2 ? Math.min(snipStart + 3, pageCount - 1) : 3

    return pages.slice(snipStart,snipEnd)
  }, [pageCount, pageIndex])

  return <div className={`is-7 pagination-section ${ pageCount <= 0 ? 'is-hidden' : '' }`} >
          <span>
            &nbsp;
            <a role="button" tabIndex="0" className="mr-1" onClick={firstPage} >&lt;&lt;</a>
            &nbsp;
            <a role="button" tabIndex="0" className="mr-1" onClick={prevPage}>&lt;</a>
            &nbsp;
            <span className="" >
              {
                sliced.map((p, i) => {
                  return <a href="#" 
                            key={i}
                            className={`m-1 ${ pageIndex + 1 === p ? "is-active" : '' }`}
                            onClick={(e) => gotoPage(p, e)} >{p}</a>     
                            })
              }
              <span className={ pageCount > 4 ? '' : 'is-hidden'} >...</span>
              <a href="#" className={`m-1 ${ pageCount > 3 ? '' : 'is-hidden'}`} onClick={(e) => gotoPage(pageCount, e)} >{ pageCount }</a>
            </span>
            &nbsp;
            <a role="button" tabIndex="0" className=" mr-1" onClick={nextPage} >&gt;</a>
            &nbsp;
            <a role="button" tabIndex="0" className="ml-1" onClick={lastPage}>&gt;&gt;</a>
          </span>
        </div>

}

export default Pagination